import categoryEn from './categoryEn';
import categorySc from './categorySc';
import categoryTc from './categoryTc';

const category = { en: categoryEn, sc: categorySc, tc: categoryTc };

export default category;